import React, { memo } from "react";
import { Link } from "react-router-dom";

interface FloatingActionButtonChildProps {
    icon: React.ReactNode;
    onClick?: () => void;
    to?: string;
    text: string;
}

const FloatingActionButtonChild: React.FC<FloatingActionButtonChildProps> = ({  icon, onClick, text, to }) => {

    const buttonClassNames = `
        lg:hidden
        bg-white border-2 border-black
        text-black
        rounded-full
        flex
        items-center
        justify-center
        p-4
        w-fit
        shadow-lg
        [&>svg]:fill-black
        [&>svg]:ml-2
    `;

    if (to) {
        return (
            <Link className={buttonClassNames} to={to}>
                <div>
                    {text}
                </div>
                {icon}
            </Link>
        );
    } else {
        return (
            <div className={buttonClassNames} onClick={onClick}>
                <div>
                    {text}
                </div>
                {icon}
            </div>
        );
    }
};

export default memo(FloatingActionButtonChild);
